import React from 'react';
import classnames from 'classnames';
import CustomNotification from '../../../Notifications/CustomNotification';
import PopperPositionedPopover from '@wix/da-ds/pkg/popper/PopperPositionedPopover';
import DefaultPopoverContent from '@wix/da-ds/pkg/popper/_partials/DefaultPopoverContent';
import popoverStyles from './PopoverWithTooltip.scss';
const NotificationPopover = ({ referenceClassName , onReferenceClick , children , tooltipOffset =[
    0,
    8
] , contentClassName , arrowClassName , notificationTypes , customNotificationRender , renderReference  })=>{
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, {
        renderPopover: ({ effectivePlacement , effectiveSecondaryPlacement , rootRef , arrowRef , contentStyle , arrowStyle , updatePositioning , arrowAttributes , contentAttributes  })=>/*#__PURE__*/ React.createElement(DefaultPopoverContent, {
                effectivePlacement: effectivePlacement,
                effectiveSecondaryPlacement: effectiveSecondaryPlacement,
                rootRef: rootRef,
                arrowRef: arrowRef,
                contentStyle: contentStyle,
                arrowStyle: arrowStyle,
                contentAttributes: contentAttributes,
                arrowAttributes: arrowAttributes,
                updatePositioning: updatePositioning,
                showArrow: true,
                wrapperClassName: popoverStyles['notification-wrapper'],
                contentClassName: classnames(contentClassName, popoverStyles['notification']),
                arrowClassName: classnames(arrowClassName, popoverStyles['notification-arrow'])
            }, /*#__PURE__*/ React.createElement(CustomNotification, {
                notificationTypes: notificationTypes,
                customNotificationRender: customNotificationRender
            })),
        placement: "top",
        secondaryPlacement: "start",
        usePortal: true,
        className: referenceClassName,
        onReferenceClick: onReferenceClick,
        offsetModifier: tooltipOffset,
        renderReference: renderReference
    }, children);
};
NotificationPopover.displayName = 'NotificationPopover';
export default NotificationPopover;
